import "./index.scss";
import { cartOn, setCartQuantity, updateCartItemsQuantity } from "@olmokit/core/cart";
import { replaceFragments, setFragmentLoading } from "@olmokit/core/fragments";
import { initItems, itemOn } from "@olmokit/core/helpers/item";
import { globalData } from "@olmokit/core/data";
import { spinners } from "@olmokit/core/forms/spinner";
import { CartRemove } from "components/Cart/Remove";
import { $, $all, forEach, on, addClass, removeClass } from "@olmokit/dom";
import { CartFooter } from "components/Cart/Footer";

/**
 * Component: CartSlide
 */
export function CartSlide() {
  console.log("CartSlide mounted.");

  CartFooter();


  if(globalData.route != 'cart'){

    CartRemove();

    // updateCart();

    cartOn("remove:fail", () => {
      updateCartSlider();
    });

    cartOn("remove:ok", ({ response }) => {
      updateCartSlider();
    });

    cartOn("add:ok", (e) => {
      console.log(e);
      updateCartSlider();
    });    

    itemOn("change", ({ data }) => {  
      setFragmentLoading("cart-footer");
      console.log('data', data);
      setCartQuantity(data).then( (res) => {    
        console.log('res', res);
        const num = checkQuantityAllItems();
        updateCartSlider();
        updateCartItemsQuantity(num);
      }).catch( () => {
        updateCartSlider();
        console.log('error');
      });
    });

    updateCartSlider()

  }

}

export function updateCartSlider() {
  replaceFragments({
    "cart-slide": "components.CartSlideInner",
  }).then(() => {
    onCartItemsReady();
  });
}

function onCartItemsReady(initial?: boolean) {
  if(globalData.route != 'cart'){
    spinners();
    initItems('cart');
  }
  return {
    destroy() { }
  }
}

function checkQuantityAllItems() {
  const $spinnerControl = $all('.CartItems: .spinnerControl');
  let count = 0;
  forEach($spinnerControl, (spin) => {
    count += parseInt(spin.value);
  });
  return count;
}